import React, { FC, useState } from 'react';

import SignUpForm, { SignUpFormData } from './components/SignUpForm';

import { useSignUpSetRoleMutation } from '@store/user';
import { Auth } from 'aws-amplify';
import { useLocation, useNavigate } from 'react-router-dom';

export enum UserType {
  PRODUCER = 'producer',
  POLICYHOLDER = 'policyholder',
  AFFILIATE = 'affiliate',
}

const SignUp: FC = () => {
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [signUpSetRole] = useSignUpSetRoleMutation();

  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const type = searchParams.get('type');
  let userType = UserType.PRODUCER;
  if (type && Object.values(UserType).includes(type as UserType)) {
    userType = type as UserType;
  }

  const onSubmitHandler = async ({ email, password }: SignUpFormData) => {
    try {
      await signUpSetRole({ email, role: userType }).unwrap();
      await Auth.signUp({
        username: email,
        password,
      });
      navigate('/email-confirmation');
    } catch (error: any) {
      if (
        error.data?.non_field_errors?.[0] ===
        'user_already_has_policyholder_profile'
      ) {
        setError('user_already_has_policyholder_profile');
      } else if (
        error.data?.non_field_errors?.[0] ===
        'user_already_has_producer_profile'
      ) {
        setError('user_already_has_producer_profile');
      } else {
        setError(
          error.code === 'UsernameExistsException'
            ? 'Error: this email address is associated with an existing account. If you forgot your password, please click here to reset your password.'
            : error.message,
        );
      }
    }
  };

  return (
    <div>
      <SignUpForm
        onSubmitHandler={onSubmitHandler}
        outerError={error}
        changeOuterError={setError}
        userType={userType}
      />
    </div>
  );
};

export default SignUp;
